// the editor may live in a detached window, so commands go through the mounted editor rather than a DOM lookup
type EditorCommandSender = (message: object) => void;

let currentSender: EditorCommandSender | null = null;

export const registerEditorCommandSender = (sender: EditorCommandSender) => {
    currentSender = sender;

    return () => {
        if (currentSender === sender) {
            currentSender = null;
        }
    };
};

export const sendEditorCommand = (message: object) => currentSender?.(message);

export const postToIframe = (iframe: HTMLIFrameElement | null, message: object) => {
    if (iframe?.src) {
        iframe.contentWindow?.postMessage(message, new URL(iframe.src).origin);
    }
};
